import Main from "./components/Main";
import Footer from "./components/Footer";

export default function App() {
    return (
        <div className="App body d-flex flex-column justify-content-center">
            <Main></Main>
            <Footer></Footer>
        </div>
    );
}